import React, {useState} from 'react'
import {Visibility, VisibilityOff} from '@material-ui/icons'
import PropTypes from 'prop-types'
import InputAdornment from '@material-ui/core/InputAdornment'
import TextInput from 'component/field/TextInput'
import fieldStyle from 'component/field/fieldStyle'
import withStyles from '@material-ui/core/styles/withStyles'
import {ReactComponent as Password} from 'style/asset/password.svg'
import cx from 'classnames'

/**
 * Simple password component with visible toggle icon
 */
const PasswordInput = (props) => {
  const {classes, input, ...rest} = props

  const [showPassword, setShowPassword] = useState(false)

  const handleClickShowPassword = (event) => {
    event.preventDefault()
    setShowPassword((showPassword) => !showPassword)
  }

  const AdornmentIcon = showPassword ? VisibilityOff : Visibility
  const inputElementType = showPassword ? 'text' : 'password'

  return (
    <TextInput
      variant={'outlined'}
      {...input}
      type={inputElementType}
      InputProps={{
        startAdornment: (
          <InputAdornment>
            <div className={classes.adornmentIcon}>
              <Password />
            </div>
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment className={classes.adornment}>
            <div
              className={cx(classes.adornmentIcon, classes.cursorPointer)}
              onClick={handleClickShowPassword}
            >
              <AdornmentIcon />
            </div>
          </InputAdornment>
        ),
      }}
      {...rest}
    />
  )
}

PasswordInput.propTypes = {
  classes: PropTypes.object,
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  rest: PropTypes.object,
}

export default withStyles(fieldStyle)(PasswordInput)
